var ShapewaysModel = require('js/lib/models/ShapewaysModel');

var FastModel = ShapewaysModel.extend({

  idAttribute:  'id',
  pluralName:   'fastModels',

  url: function() {
    return '/product/custom-maker?modelId=' + this.id + '&adapterType=' + this.pluralName;
  },

  defaults: {
    'id': -1,
    'baseUrl': '',
    'baseUrlAnalytical': '',
    'baseUrlVisual': '',
    'cocreatorFormFieldIds': [],
    'cocreatorFormFieldData': [],
    'modelCocreatorData': {},
    'modelRotationData': {}
  },

  getModelRotationData: function getModelRotationData() {
    return this.get('modelRotationData');
  },

  getModelCocreatorData: function getModelCocreatorData() {
  	return this.get('modelCocreatorData');
  },

  getCocreatorFormFieldData: function getCocreatorFormFieldData() {
  	return this.get('cocreatorFormFieldData');
  },

  getCocreatorFormFieldIds: function getCocreatorFormFieldIds() {
    return this.get('cocreatorFormFieldIds');
  },

  /**
   * Returns urls to get model. Used mostly by C-maker
   *
   * @returns {{baseUrl: *, baseUrlAnalytical: *, baseUrlVisual: *}}
   */
  getUrls: function getUrls() {
    return {
      baseUrl: this.get('baseUrl'),
      baseUrlAnalytical: this.get('baseUrlAnalytical'),
      baseUrlVisual: this.get('baseUrlVisual')
    };
  }

});

module.exports = FastModel;
